import http from '../http.service'

const STATUS_RETRY_DELAYS_MS = [2000, 5000, 15000, 30000, 60000]

export default class KkmBackendApi {
  constructor (token) {
    this.confirmUrl = '/print/kkm-server/commands/{commandId}/confirm'
    this.releaseUrl = '/print/kkm-server/commands/{commandId}/release'
    this.statusUrl = '/print/kkm-server/commands/{commandId}/status'
    this.errorUrl = '/print/kkm-server/commands/{commandId}/error'

    this._token = token
  }

  getRequestConfig () {
    return {
      headers: {
        ...http.defaults.headers,
        Token: this._token,
      },
    }
  }

  async _post (urlTemplate, commandId, data = null) {
    const url = urlTemplate.replace('{commandId}', commandId)
    const response = await http.post(url, data, this.getRequestConfig())
    return response.data
  }

  /**
   * Атомарный клейм команды на бэке. Вкладка выполняет команду только
   * после claimed=true; повтор с тем же claimerToken идемпотентен.
   * @returns {Promise<boolean>}
   */
  async claim (commandId, claimerToken) {
    const result = await this._post(this.confirmUrl, commandId, { claimerToken })
    return Boolean(result && result.claimed)
  }

  // Возврат клейма - только при гарантированной неотправке (проба провалена)
  async release (commandId) {
    return this._post(this.releaseUrl, commandId)
  }

  async sendCommandStatus (commandId, data) {
    return this._post(this.statusUrl, commandId, data)
  }

  async sendCommandError (commandId, data) {
    return this._post(this.errorUrl, commandId, data)
  }

  /**
   * Доставка результата с ретраями. Резолвится true при успехе или
   * осмысленном отказе бэка (4xx - команда уже завершена), false - когда
   * попытки исчерпаны: запись останется в журнале и будет дослана
   * восстановлением.
   */
  async sendCommandStatusWithRetries (commandId, data) {
    for (const delayMs of [0, ...STATUS_RETRY_DELAYS_MS]) {
      if (delayMs) await new Promise(resolve => setTimeout(resolve, delayMs))
      try {
        await this.sendCommandStatus(commandId, data)
        return true
      } catch (e) {
        const status = e && e.response && e.response.status
        if (status >= 400 && status < 500) {
          return true
        }
      }
    }
    return false
  }
}
